import KCFLogoDarkSvg from 'assets/branding/KCF-dark.svg';
import KCFLogoSvg from 'assets/branding/KCF-light.svg';
import SDIconDark from 'assets/branding/SdIcon-dark.svg';
import SDIcon from 'assets/branding/SdIcon-light.svg';
import SmartDiagnosticsDark from 'assets/branding/SMARTdiagnostics-dark.svg';
import SmartDiagnostics from 'assets/branding/SMARTdiagnostics-light.svg';
import { useTheme } from 'contexts/ThemeContext';
import { isDark } from 'styles/colorMode';

type KCFLogoProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
    icon: ImageKey;
};

type ThemeCat = 'light' | 'dark';
type ImageKey = 'kcf-logo' | 'sd-logo' | 'smart-diagnostics';

const imageLookup: Record<ThemeCat, Record<ImageKey, SVG>> = {
    light: {
        'kcf-logo': KCFLogoSvg,
        'sd-logo': SDIcon,
        'smart-diagnostics': SmartDiagnostics,
    },
    dark: {
        'kcf-logo': KCFLogoDarkSvg,
        'sd-logo': SDIconDark,
        'smart-diagnostics': SmartDiagnosticsDark,
    },
};

export function ThemedImage({ icon, ...props }: KCFLogoProps) {
    const { colorMode } = useTheme();
    const src = imageLookup[isDark(colorMode) ? 'dark' : 'light'][icon];
    return <img src={src} alt="KCF Logo" {...props} />;
}
